import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { StaffMember, StaffFormData } from '../types/staff';

export const staffApi = {
	listStaff: async (locationId: number): Promise<StaffMember[]> => {
		return apiClient.get<StaffMember[]>(`${API_ENDPOINTS.STAFF.BASE}?locationId=${locationId}`);
	},

	createStaff: async (locationId: number, data: StaffFormData): Promise<StaffMember> => {
		return apiClient.post<StaffMember>(
			`${API_ENDPOINTS.STAFF.BASE}?locationId=${locationId}`,
			data
		);
	},

	updateStaff: async (
		staffId: number,
		locationId: number,
		data: StaffFormData
	): Promise<StaffMember> => {
		return apiClient.put<StaffMember>(
			`${API_ENDPOINTS.STAFF.DETAIL(staffId)}?locationId=${locationId}`,
			data
		);
	},

	searchStaff: async (query: string): Promise<StaffMember[]> => {
		return apiClient.get<StaffMember[]>(
			`${API_ENDPOINTS.STAFF.SEARCH}?query=${encodeURIComponent(query)}`
		);
	},
};

export default staffApi;
